const MailConfig = () => import('Views/systemConfig/mail-config');
const LoadAnimation = () => import('Views/loadAnimation/index');
const Menu = () => import('Views/menu/index');
const Role = () => import('Views/role/index');
const Notice = () => import('Views/notice/index');

export default[
  { path: '/', component: LoadAnimation },
  { path: '/mail-config', component: MailConfig },
  { path: '/menu', component: Menu },
  { path: '/role', component: Role },
  { path: '/notice', component: Notice },
];



// WEBPACK FOOTER //
// ./src/router/systemConfig.js